"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
const areaSelector_1 = require("./areaSelector");
var PageHeight;
(function (PageHeight) {
    PageHeight[PageHeight["A3"] = 297] = "A3";
    PageHeight[PageHeight["A4"] = 210] = "A4";
})(PageHeight = exports.PageHeight || (exports.PageHeight = {}));
const PAGE_MARGIN = 10 /*mm*/;
function getScale({ selection, pageType, orientation, margin = PAGE_MARGIN }) {
    const index = orientation === areaSelector_1.Orientation.LANDSCAPE ? 1 : 0;
    const mapAreaLength = Math.abs(selection.bottomRight[index] - selection.topLeft[index]);
    const pageLength = (pageType /*mm*/ - 2 * margin) / 1000; /*m*/
    return Math.round(mapAreaLength / pageLength);
}
exports.getScale = getScale;
function getSelectionForScale({ scale, selection, pageType, orientation, margin = PAGE_MARGIN }) {
    const index = orientation === areaSelector_1.Orientation.LANDSCAPE ? 1 : 0;
    const otherIndex = (index + 1) % 2;
    const ISO216PaperRatio = 1 / Math.sqrt(2);
    const pageLength = (pageType /*mm*/ - 2 * PAGE_MARGIN) / 1000; /*m*/
    selection.bottomRight[index] = selection.topLeft[index] - pageLength * scale;
    selection.bottomRight[otherIndex] = selection.topLeft[otherIndex] + pageLength * scale / ISO216PaperRatio;
    return selection;
}
exports.getSelectionForScale = getSelectionForScale;



//////////////////
// WEBPACK FOOTER
// ./src/map/mapScale.ts
// module id = 286
// module chunks = 0